<template>
  <div id="app">
    <router-view></router-view>
    <!-- <lg-preview></lg-preview> -->
    <back-to-top></back-to-top>
  </div>
</template>

<script>
import BackToTop from './components/backToTop.vue'
export default {
  components: {
    BackToTop
  },
  name: 'app',

  data() {
    return {
      seoKeywords: '',
      seoDesc: '',
    }
  },

  metaInfo() {
    return {
      meta: [
        { name: "keywords", content: this.seoKeywords },
        { name: "description", content: this.seoDesc },
      ],
    };
  },

  created() {
    this.getseo()
  },

  methods: {
    // 获取SEO参数
    async getseo() {
      let _this = this
      const res = await _this.get_res('/subAndLibraryAndSiteInfo?sld=AHSCXB')
      // seoDesc: "安徽"
      // seoKeywords: "安徽图片
      _this.seoDesc = res.data.subInfo.seoDesc
      _this.seoKeywords = res.data.subInfo.seoKeywords
    },
  }


}
</script>

<style>
#app {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
}

*,
*:after,
*:before {
  box-sizing: border-box;
  /* font-family: Source Han Sans CN; */
}

body,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
blockquote,
dl,
dt,
dd,
ul,
ol,
li,
pre,
form,
fieldset,
legend,
button,
input,
textarea,
th,
td {
  margin: 0;
  padding: 0
}

body,
button,
input,
select,
textarea {
  font: 12px Arial, Helvetica, sans-serif
}

body,
html {
  overflow: hidden !important;
  padding: 0 !important;
  /* overflow-x: hidden; */
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  color: #333;
  font-family: '微软雅黑', 'YaHei', '黑体', 'Hei', Tahoma, Helvetica, arial, sans-serif;
}

address,
cite,
dfn,
em,
var {
  font-style: normal
}

code,
kbd,
pre,
samp {
  font-family: courier new, courier, monospace
}

ul,
ol,
li {
  list-style: none
}

a {
  text-decoration: none;
  outline: none;
  color: inherit;
  color: #333 !important;
}

a:hover {
  /* opacity: 0.7; */
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  outline: none;
}

sup {
  vertical-align: text-top
}

sub {
  vertical-align: text-bottom
}

legend {
  color: #000
}

fieldset,
img {
  border: 0
}

button,
input,
select,
textarea {
  font-size: 100%;
}

textarea {
  resize: none
}

button,
input {
  margin: 0;
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  line-height: 1;
  box-sizing: border-box;
}

button:hover {
  cursor: pointer;
}

select {
  padding: 2px;
  border: 1px solid #ddd;
  -moz-border-radius: 3px;
  -khtml-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px
}

table {
  border-collapse: collapse;
  border-spacing: 0
}

img {
  vertical-align: top;
  display: inline-block;
  background-color: none;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section,
summary,
time,
mark,
audio,
video {
  display: block;
  margin: 0;
  padding: 0
}

object,
embed {
  outline: 0
}
</style>
